export type Benefit = {
  title: string
  text: string
  image: string
  /** Optimierte quadratische Version (600×600) für Desktop ab 1024px. */
  imageDesktop?: string
  /** Optimierte quadratische Version für Handys (bis 639px). */
  imageMobile?: string
  imageAlt: string
  /** CSS object-position für den quadratischen Ausschnitt der Karte. */
  imagePosition?: string
  /** Abweichender Ausschnitt nur für die Handy-Ansicht. */
  imagePositionMobile?: string
  /** Abweichender Ausschnitt nur für die Tablet-Ansicht. */
  imagePositionTablet?: string
  /** Zeigt das Bild auf Handys ohne Beschnitt (quadratischer Rahmen). */
  imageFullMobile?: boolean
}

export const benefits: Benefit[] = [
  {
    title: 'Keine nervige Kaltaquise',
    text: 'Du sprichst mit Menschen, die bereits Interesse gezeigt und sich aktiv für ein Gespräch eingetragen haben. Kein Hinterhertelefonieren, keine endlosen Kontaktlisten – die Unternehmen sorgen für die Leads und legen dir qualifizierte Termine direkt in den Kalender.',
    image:
      'https://cdn.magicpatterns.com/uploads/6tYfMTuthUBBhA57XjGecc/closing-gespraeche-ohne-kaltakquise.webp',
    imageDesktop:
      'https://cdn.magicpatterns.com/uploads/hntXHBiDAtiBbXQ7sB6kmE/closing-gespraeche-ohne-kaltakquise.desktop.webp',
    imageAlt: 'Closing-Gespräche ohne Kaltakquise – Hot Sales Girl mit Smartphone im Gespräch',
    imagePosition: 'center 35%',
    imagePositionTablet: 'center 18%',
  },
  {
    title: 'Authentisch Gespräche führen',
    text: 'Lerne, wie du mit Empathie, echtem Zuhören und den richtigen Fragen erfolgreich abschließt. Statt aggressiver Verkaufstaktiken führst du Gespräche auf Augenhöhe, verstehst, was dein Gegenüber wirklich braucht, und begleitest Interessenten authentisch zu ihrer Entscheidung.',
    image:
      'https://cdn.magicpatterns.com/uploads/cDMxsbBq1hseCinXRRvmNT/hot-sales-girls-community-event-yacht.webp',
    imageDesktop:
      'https://cdn.magicpatterns.com/uploads/r7XUccJCEidHSyivqC5ZJU/hot-sales-girls-community-event-yacht.desktop.webp',
    imageMobile:
      'https://cdn.magicpatterns.com/uploads/iZzXnWWSH962aYtpXoiavE/hot-sales-girls-community-event-yacht.mobile.webp',
    imageAlt: 'Hot Sales Girls Community-Event auf einer Yacht mit Teilnehmerinnen der Academy',
    imagePositionMobile: 'center 45%',
    imagePositionTablet: 'center 45%',
  },
  {
    title: 'Wir begleiten dich auf dem Weg zu deinem Remote Job',
    text: 'Wir zeigen dir, wie du passende Unternehmen und High-Ticket-Projekte findest und dich erfolgreich positionierst. Zusätzlich profitierst du von unserem internationalen Netzwerk aus Unternehmen, Coaches und Dienstleistern. Und wir bleiben an deiner Seite – von der Suche bis zu deinen ersten erfolgreichen Abschlüssen und darüber hinaus.',
    image:
      'https://cdn.magicpatterns.com/uploads/2um2XcXVkk6cEojhXJtyo3/remote-job-closerin-wochenplan-laptop.webp',
    imageDesktop:
      'https://cdn.magicpatterns.com/uploads/bQQQygDzbmCWtLiCvB6ynE/remote-job-closerin-wochenplan-laptop.desktop.webp',
    imageMobile:
      'https://cdn.magicpatterns.com/uploads/9PVJK1yj4stpdZVpU2J5u8/remote-job-closerin-wochenplan-laptop.mobile.webp',
    imageAlt:
      'Remote Job als Hot Sales Girl: Wochenplan auf dem Laptop mit Hot Sales Girls Tasse am Pool',
    imagePosition: 'center 78%',
    imagePositionMobile: 'center 55%',
  },
  {
    title: 'Ortsunabhängig & Flexibilität',
    text: 'Alles, was du brauchst, ist dein Smartphone und WLAN. Arbeite von wo du möchtest, und gestalte deinen Arbeitsalltag nach deinen Vorstellungen. Du entscheidest selbst, wann und wie viel du arbeitest. Mehr Freiheit, mehr Flexibilität – und ein Job, der sich deinem Leben anpasst, nicht umgekehrt.',
    image:
      'https://cdn.magicpatterns.com/uploads/6eGBbcNePbEjPdtx2oMw9y/ortsunabhaengig-arbeiten-als-closerin.webp',
    imageDesktop:
      'https://cdn.magicpatterns.com/uploads/6ML9VRAAkPDBXMnNUPsET6/ortsunabhaengig-arbeiten-als-closerin.desktop.webp',
    imageMobile:
      'https://cdn.magicpatterns.com/uploads/ufEv8i6Tk1HU2njZL3Qt89/ortsunabhaengig-arbeiten-als-closerin.mobile.webp',
    imageAlt: 'Ortsunabhängig arbeiten als Hot Sales Girl – Teilnehmerinnen der Academy am Pool',
    imagePosition: 'center 55%',
  },
]

export type Step = {
  label: string
  title: string
  text: string
}

export const steps: Step[] = [
  {
    label: '01',
    title: 'Die Fakten',
    text: 'Weltweit verkaufen Unternehmen hochpreisige Produkte und Dienstleistungen – von Coachings bis zu Premium-Services. Gerade in Gesundheit, Lifestyle und Persönlichkeitsentwicklung sind die Kundinnen häufig Frauen.',
  },
  {
    label: '02',
    title: 'Deine Chance',
    text: 'Diese Angebote sind erklärungsbedürftig. Interessentinnen wünschen sich vor der Entscheidung ein Gespräch mit jemandem, der ihre Situation wirklich versteht – und genau da kommst du ins Spiel.',
  },
  {
    label: '03',
    title: 'Deine Aufgabe',
    text: 'Als Hot Sales Girl übernimmst du die persönliche Beratung. Die Termine kommen vom Unternehmen, du klärst Fragen, nimmst Unsicherheiten und begleitest seriös – ohne Druck.',
  },
]

export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Wie lange dauert die Academy?',
    answer: 'Die Academy und unsere Community sind so aufgebaut, dass du komplett flexibel und in deinem eigenen Tempo lernen kannst. Du bist an keine festen Zeiten gebunden und kannst dir die Inhalte Schritt für Schritt so einteilen, wie es zu deinem Alltag passt – egal ob nebenberuflich oder Vollzeit.',
  },
  {
    question: 'Brauche ich Startkapital?',
    answer: 'Für die Tätigkeit selbst brauchst du kein Kapital, keine Ware und kein Lager. Was du brauchst, ist ein Laptop oder Handy, eine stabile Internetverbindung und Zeit für die Trainings.',
  },
  {
    question: 'Geht das auch nebenberuflich?',
    answer: 'Ja, absolut. Viele unserer Teilnehmerinnen starten neben ihrem Job, Studium oder bestehenden Business. Durch den flexiblen Aufbau kannst du die Academy in deinem eigenen Tempo absolvieren – ohne direkt alles andere aufgeben zu müssen.',
  },
  {
    question: 'Wie geht es nach der Academy weiter?',
    answer: 'Wir lassen dich nach der Academy nicht allein. Über unser internationales Netzwerk und unsere langjährige Erfahrung zeigen wir dir, wie du passende Remote-Jobs findest und begleiten dich auf deinem Weg in dein erstes Projekt. Auch bei deinen ersten Gesprächen und Einnahmen sind wir weiterhin an deiner Seite. Der Zugang zu unserer Community bleibt dir erhalten, sodass du langfristig Ansprechpartner und ein starkes Netzwerk an deiner Seite hast.',
  },
  {
    question: 'Wie schnell kann ich meine ersten Einnahmen erzielen?',
    answer: 'Das Tempo ist bei jeder Frau unterschiedlich. Manche haben nach ein paar Wochen bereits ihre ersten Einnahmen, andere benötigen dafür etwas mehr Zeit. Garantien gibt es keine.',
  },
  {
    question: 'Muss ich auf Social Media aktiv sein?',
    answer: 'Nein. Du brauchst weder Reichweite noch musst du regelmäßig Content posten oder ein eigenes Produkt haben. Die Termine landen automatisch in deinem Kalender von deinem Auftraggeber.',
  },
  {
    question: 'Für wen ist die Academy geeignet?',
    answer: 'Für Frauen, die mehr aus sich und ihrem Leben machen wollen – egal, ob du komplette Quereinsteigerin bist, bereits im Sales arbeitest oder dein eigenes Business hast. Entscheidend ist nicht deine Vorerfahrung, sondern dass du bereit bist zu lernen, umzusetzen und an deinen Skills zu arbeiten. Vorerfahrung brauchst du dafür keine.',
  },
  {
    question: 'Für wen ist die Academy nicht geeignet?',
    answer: 'Für alle, die nach schnellem Geld ohne Einsatz suchen. Die Academy ist für Frauen, die bereit sind, neue Skills zu lernen, ins Handeln zu kommen und Verantwortung für ihre Ergebnisse zu übernehmen. Wir geben dir das Wissen, die Tools und die Begleitung – umsetzen musst du selbst.',
  },
]
